import React, { useState } from 'react';
import DateRangePicker, { defaultRange } from '../../components/analytics/DateRangePicker';
import OverviewTab from '../../components/analytics/OverviewTab';
import PaymentFunnelTab from '../../components/analytics/PaymentFunnelTab';
import SearchFunnelTab from '../../components/analytics/SearchFunnelTab';
import NotificationsTab from '../../components/analytics/NotificationsTab';
import WebsiteTab from '../../components/analytics/WebsiteTab';
import { DateRange } from '../../lib/panelTypes';

type Tab = 'overview' | 'payments' | 'search' | 'notifications' | 'website';

const TABS: { key: Tab; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'payments', label: 'Payment funnel' },
  { key: 'search', label: 'Search funnel' },
  { key: 'notifications', label: 'Notifications' },
  { key: 'website', label: 'Website' },
];

const Dashboard: React.FC = () => {
  const [range, setRange] = useState<DateRange>(defaultRange());
  const [tab, setTab] = useState<Tab>('overview');

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-1">Analytics</h2>
          <p className="text-gray-600">Product analytics for FreeSpot — {range.label.toLowerCase()}</p>
        </div>
        <DateRangePicker value={range} onChange={setRange} />
      </div>

      <div className="border-b border-gray-200">
        <nav className="flex gap-1 -mb-px">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                tab === t.key
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {tab === 'overview' && <OverviewTab range={range} />}
      {tab === 'payments' && <PaymentFunnelTab range={range} />}
      {tab === 'search' && <SearchFunnelTab range={range} />}
      {tab === 'notifications' && <NotificationsTab range={range} />}
      {tab === 'website' && <WebsiteTab range={range} />}
    </div>
  );
};

export default Dashboard;
